<p-tabView [activeIndex]="activeTabIndex">
  <p-tabPanel header="{{ 'SEARCH.BY_PATIENT' | translate }}">
    <app-search-by-patient
      (onSearch)="onSearchByPatient($event)"
      [searchInfo]="patientSearch$ | async"
    >
    </app-search-by-patient>
  </p-tabPanel>

  <p-tabPanel header="{{ 'SEARCH.BY_REQUEST' | translate }}">
    <app-search-by-request
      (onSearch)="onSearchByRequest($event)"
      [searchInfo]="requestSearch$ | async"
    >
    </app-search-by-request>
  </p-tabPanel>
</p-tabView>
